import { STAGES_AR } from "constants/constants";
import { useState } from "react";
import { createPortal } from "react-dom";

const WisdomDashboardGeneralInfo = ({ generalInfo, selectedOrg, setShowUserProfilePopup, setSelectedUserRole, setSelectedUserId, setShowWorkShopPopup, setSelectedWorkshopId }) => {
    const [openDropdown, setOpenDropdown] = useState("");
    const [openSpecializationId, setOpenSpecializationId] = useState(null);
    const [dropdownPos, setDropdownPos] = useState({ top: 0, bottom: 0, right: 0, openUp: false, subMenuOnLeft: false });

    const openWorkShopDetails = (id) => {
        setSelectedWorkshopId(id);
        setShowWorkShopPopup(true);
    }

    const VIEWPORT_MARGIN = 8;

    const countStagesStudents = (stages) => (stages ?? []).reduce((sum, item) => sum + (item.students?.length ?? 0), 0);

    const toggleDropdown = (name, e, menuWidth = 192) => {
        setOpenSpecializationId(null);
        if (openDropdown === name) {
            setOpenDropdown("");
            return;
        }
        const rect = e.currentTarget.closest("td").getBoundingClientRect();

        // keep the menu fully inside the viewport horizontally
        const right = Math.max(
            VIEWPORT_MARGIN,
            Math.min(window.innerWidth - rect.right, window.innerWidth - menuWidth - VIEWPORT_MARGIN)
        );
        const menuLeft = window.innerWidth - right - menuWidth;

        setDropdownPos({
            top: rect.bottom + 4,
            bottom: window.innerHeight - rect.top + 4,
            right,
            // open towards the side that has more room
            openUp: rect.top > window.innerHeight - rect.bottom,
            subMenuOnLeft: menuLeft > right,
        });
        setOpenDropdown(name);
    }

    const menuStyle = dropdownPos.openUp
        ? { bottom: dropdownPos.bottom, right: dropdownPos.right }
        : { top: dropdownPos.top, right: dropdownPos.right };

    const bridgeStyle = dropdownPos.subMenuOnLeft ? { right: "100%", left: "auto" } : { left: "100%" };

    const subMenuStyle = {
        ...(dropdownPos.subMenuOnLeft
            ? { right: "100%", left: "auto", marginRight: 4, marginLeft: 0 }
            : { left: "100%", right: "auto", marginLeft: 4, marginRight: 0 }),
        ...(dropdownPos.openUp ? { bottom: 0, top: "auto" } : { top: 0, bottom: "auto" }),
    };

    return (
        <div className="w-full h-[45%] min-h-0 flex flex-col justify-between items-center gap-2 xl:text-base md:text-xs text-xs overflow-hidden">
            <div className="flex-1 min-h-0 w-full rounded-xl border border-slate-200/70 shadow-sm overflow-hidden">
                <table className="w-full h-full table-fixed" dir="rtl">
                    <thead>
                        <tr className="bg-[#5268b1] border-b border-blue-200/60 text-white">
                            <th className="py-1 text-center font-semibold">اجمالي الموظفين</th>
                            <th className="py-1 text-center font-semibold">مديرين</th>
                        </tr>
                    </thead>

                    <tbody className="divide-y divide-slate-100">
                        <tr className="bg-[#2f417a] hover:bg-slate-50 transition-colors">
                            <td className="py-2 text-center">
                                <span className={`h-6 inline-flex items-center justify-center min-w-[2.25rem] px-2 rounded-full cursor-pointer ${(selectedOrg?.no_of_employees ?? 0) > 0 ? 'bg-blue-100 text-blue-800' : 'bg-slate-100 text-black'}`}>
                                    {generalInfo[selectedOrg?.id]?.employees.length ?? 0}
                                </span>
                            </td>
                            <td className="relative py-2 text-center align-middle">
                                <span
                                    onClick={(e) => toggleDropdown("manager", e)}
                                    className="min-w-[2.25rem] h-6 inline-flex items-center justify-center text-blue-800 bg-blue-100 px-2 rounded-full cursor-pointer"
                                >
                                    {generalInfo[selectedOrg?.id]?.managers.length}
                                </span>
                                {openDropdown === "manager" && createPortal(
                                    <div className="fixed text-black bg-white border rounded-lg shadow-xl w-48 z-[9999]" style={menuStyle}>
                                        <ul className="text-sm">
                                            <li className="relative">
                                                <div className="group px-4 py-2 hover:bg-gray-100 cursor-pointer whitespace-nowrap">
                                                    مدير مركز ({generalInfo[selectedOrg?.id]?.managers.length})

                                                    {/* bridge area so hover doesn't break */}
                                                    <div className="absolute top-0 w-3 h-full" style={bridgeStyle} />

                                                    {/* Submenu */}
                                                    <div style={subMenuStyle} className="
                                                                    absolute left-full bottom-0 ml-1
                                                                    bg-white border rounded-lg shadow-lg w-44 z-50 max-h-40 overflow-y-auto
                                                                    opacity-0 invisible
                                                                    group-hover:opacity-100 group-hover:visible
                                                                    transition-all duration-300 ease-out
                                                                    "
                                                    >
                                                        <ul>
                                                            {generalInfo[selectedOrg?.id]?.managers.map((manager, idx) => (
                                                                <li
                                                                    key={idx}
                                                                    onClick={() => {
                                                                        setSelectedUserId(manager.user_id);
                                                                        setSelectedUserRole("Employee");
                                                                        setShowUserProfilePopup(true);
                                                                        setOpenDropdown("");
                                                                    }}
                                                                    className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                                                                >
                                                                    {manager.first_name} {manager.middle_name} {manager.last_name}
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>,
                                    document.body
                                )}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="flex-1 min-h-0 w-full rounded-xl border border-slate-200/70 shadow-sm overflow-hidden">
                <table className="w-full h-full table-fixed" dir="rtl">
                    <thead>
                        <tr className="bg-[#5268b1] border-b border-blue-200/60 text-white">
                            <th className="py-1 text-center font-semibold">الاداريين</th>
                            <th className="py-1 text-center font-semibold">المعلمين</th>
                            <th className="py-1 text-center font-semibold">الطلاب</th>
                        </tr>
                    </thead>

                    <tbody className="w-full divide-y divide-slate-100">
                        <tr className="bg-[#2f417a] hover:bg-slate-50 transition-colors">
                            <td className="relative py-2 text-center align-middle">
                                <span
                                    onClick={(e) => toggleDropdown("admins", e)}
                                    className="min-w-[2.25rem] h-6 inline-flex items-center justify-center text-blue-800 bg-blue-100 px-2 rounded-full cursor-pointer"
                                >
                                    {generalInfo[selectedOrg?.id]?.admins.length}
                                </span>
                                {openDropdown === "admins" && createPortal(
                                    <div className="fixed text-black bg-white border rounded-lg shadow-xl w-48 z-[9999]" style={menuStyle}>
                                        <ul className="text-sm">
                                            <li className="relative">
                                                <div className="group px-4 py-2 hover:bg-gray-100 cursor-pointer whitespace-nowrap">
                                                    الاداريين ({generalInfo[selectedOrg.id]?.admins.length})

                                                    {/* bridge area so hover doesn't break */}
                                                    <div className="absolute top-0 w-3 h-full" style={bridgeStyle} />

                                                    {/* Submenu */}
                                                    <div style={subMenuStyle} className="
                                                      absolute left-full bottom-0 ml-1
                                                      bg-white border rounded-lg shadow-lg w-44 z-50 max-h-40 overflow-y-auto
                                                      opacity-0 invisible
                                                      group-hover:opacity-100 group-hover:visible
                                                      transition-all duration-300 ease-out
                                                    ">
                                                        <ul>
                                                            {generalInfo[selectedOrg.id]?.admins.map((admin, idx) => (
                                                                <li
                                                                    key={idx}
                                                                    onClick={() => {
                                                                        setSelectedUserId(admin.user_id);
                                                                        setSelectedUserRole("Employee");
                                                                        setShowUserProfilePopup(true);
                                                                        setOpenDropdown("");
                                                                    }}
                                                                    className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                                                                >
                                                                    {admin.first_name} {admin.middle_name} {admin.last_name}
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>,
                                    document.body
                                )}
                            </td>
                            <td className="relative py-2 text-center align-middle">
                                <span
                                    onClick={(e) => toggleDropdown("teachers", e, 224)}
                                    className="min-w-[2.25rem] h-6 inline-flex items-center justify-center text-blue-800 bg-blue-100 px-2 rounded-full cursor-pointer"
                                >
                                    {generalInfo[selectedOrg?.id]?.teachers?.reduce(
                                        (sum, item) => sum + (item.teachers?.length || 0),
                                        0
                                    )}
                                </span>
                                {openDropdown === "teachers" && createPortal(
                                    <div className="fixed text-black bg-white border rounded-lg shadow-xl w-56 z-[9999]" style={menuStyle}>
                                        <ul className="text-sm">
                                            {generalInfo?.[selectedOrg?.id]?.teachers.map((group) => (
                                                <li key={group.subject?.id} className="relative group">
                                                    {/* Main item: subject name + count */}
                                                    <div className="px-4 py-2 hover:bg-gray-100 cursor-pointer whitespace-nowrap flex justify-between gap-3">
                                                        <span>{group.subject?.name}</span>
                                                        <span className="text-xs text-slate-600">({group.teachers?.length ?? 0})</span>
                                                    </div>

                                                    {/* bridge */}
                                                    <div className="absolute top-0 w-3 h-full bg-transparent" style={bridgeStyle} />

                                                    {/* Side menu: teachers list */}
                                                    <div
                                                        style={subMenuStyle}
                                                        className="
                                                                        absolute left-full top-0 ml-1
                                                                        hidden group-hover:block
                                                                        bg-white border rounded-lg shadow-lg w-60 z-[9999]
                                                                        max-h-48 overflow-y-auto
                                                                    "
                                                    >
                                                        <ul>
                                                            {(group.teachers ?? []).map((teacher) => (
                                                                <li
                                                                    key={teacher.id}
                                                                    onClick={() => {
                                                                        setSelectedUserId(teacher.user_id);
                                                                        setSelectedUserRole("Teacher");
                                                                        setShowUserProfilePopup(true);
                                                                        setOpenDropdown("");
                                                                    }}
                                                                    className="px-4 py-2 hover:bg-gray-100 cursor-pointer whitespace-nowrap"
                                                                >
                                                                    {teacher.first_name} {teacher.middle_name} {teacher.last_name}
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>,
                                    document.body
                                )}
                            </td>
                            <td className="relative py-2 text-center align-middle">
                                <span
                                    onClick={(e) => toggleDropdown("students", e, 224)}
                                    className="min-w-[2.25rem] h-6 inline-flex items-center justify-center text-blue-800 bg-blue-100 px-2 rounded-full cursor-pointer"
                                >
                                    {generalInfo[selectedOrg?.id]?.students?.reduce((sum, group) => sum + countStagesStudents(group.stages), 0)}
                                </span>
                                {openDropdown === "students" && createPortal(
                                    <div className="fixed text-black bg-white border rounded-lg shadow-xl w-56 z-[9999]" style={menuStyle}>
                                        <ul className="text-sm">
                                            {generalInfo?.[selectedOrg?.id]?.students.map((group) => (
                                                <li key={group.specialization?.id} className="relative">
                                                    {/* Main item: specialization name + count (click to show stages) */}
                                                    <div
                                                        onClick={() => setOpenSpecializationId(openSpecializationId === group.specialization?.id ? null : group.specialization?.id)}
                                                        className={`px-4 py-2 hover:bg-gray-100 cursor-pointer whitespace-nowrap flex justify-between gap-3 ${openSpecializationId === group.specialization?.id ? 'bg-gray-100' : ''}`}
                                                    >
                                                        <span>{group.specialization?.name}</span>
                                                        <span className="text-xs text-slate-600">({countStagesStudents(group.stages)})</span>
                                                    </div>

                                                    {/* Side menu: stages list */}
                                                    {openSpecializationId === group.specialization?.id && (
                                                        <div
                                                            style={subMenuStyle}
                                                            className="absolute bg-white border rounded-lg shadow-lg w-44 z-[9999]"
                                                        >
                                                            <ul>
                                                                {(group.stages ?? []).toSorted((a, b) => (a.stage?.id ?? 0) - (b.stage?.id ?? 0)).map((stageGroup) => (
                                                                    <li key={stageGroup.stage?.id} className="relative group/stage">
                                                                        <div className="px-4 py-2 hover:bg-gray-100 cursor-pointer whitespace-nowrap flex justify-between gap-3">
                                                                            <span>{STAGES_AR[stageGroup.stage?.name]}</span>
                                                                            <span className="text-xs text-slate-600">({stageGroup.students?.length ?? 0})</span>
                                                                        </div>

                                                                        {/* bridge */}
                                                                        <div className="absolute top-0 w-3 h-full bg-transparent" style={bridgeStyle} />

                                                                        {/* Side menu: students list */}
                                                                        <div
                                                                            style={subMenuStyle}
                                                                            className="
                                                                                absolute
                                                                                hidden group-hover/stage:block
                                                                                bg-white border rounded-lg shadow-lg w-60 z-[9999]
                                                                                max-h-48 overflow-y-auto
                                                                            "
                                                                        >
                                                                            <ul>
                                                                                {(stageGroup.students ?? []).map((student) => (
                                                                                    <li
                                                                                        key={student.id}
                                                                                        onClick={() => {
                                                                                            setSelectedUserId(student.user_id);
                                                                                            setSelectedUserRole("Student");
                                                                                            setShowUserProfilePopup(true);
                                                                                            setOpenDropdown("");
                                                                                        }}
                                                                                        className="px-4 py-2 hover:bg-gray-100 cursor-pointer whitespace-nowrap"
                                                                                    >
                                                                                        {student.first_name} {student.middle_name} {student.last_name}
                                                                                    </li>
                                                                                ))}
                                                                            </ul>
                                                                        </div>
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        </div>
                                                    )}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>,
                                    document.body
                                )}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="flex-1 min-h-0 w-full rounded-xl border border-slate-200/70 shadow-sm overflow-hidden">
                <table className="w-full h-full table-fixed" dir="rtl">
                    <thead>
                        <tr className="bg-[#5268b1] border-b border-blue-200/60 text-white">
                            <th className="py-1 text-center font-semibold">الورش</th>
                            <th className="py-1 text-center font-semibold">المعامل</th>
                            <th className="py-1 text-center font-semibold">الفصول</th>
                        </tr>
                    </thead>

                    <tbody className="divide-y divide-slate-100">
                        <tr className="bg-[#2f417a] hover:bg-slate-50 transition-colors">

                            <td className="relative py-2 text-center align-middle">
                                <span
                                    onClick={(e) => toggleDropdown("workshops", e)}
                                    className="min-w-[2.25rem] h-6 inline-flex items-center justify-center text-blue-800 bg-blue-100 px-2 rounded-full cursor-pointer"
                                >
                                    {generalInfo[selectedOrg?.id]?.workshops.length}
                                </span>
                                {openDropdown === "workshops" && createPortal(
                                    <div className="fixed text-black bg-white border rounded-lg shadow-xl w-48 z-[9999]" style={menuStyle}>
                                        <ul className="text-sm">
                                            <li className="relative">
                                                <div className="group px-4 py-2 hover:bg-gray-100 cursor-pointer whitespace-nowrap">
                                                    ورشة ({generalInfo[selectedOrg?.id]?.workshops.length})

                                                    {/* bridge area so hover doesn't break */}
                                                    <div className="absolute top-0 w-3 h-full" style={bridgeStyle} />

                                                    {/* Submenu */}
                                                    <div style={subMenuStyle} className="
                                                                    absolute left-full bottom-0 ml-1
                                                                    bg-white border rounded-lg shadow-lg w-44 z-50 max-h-40 overflow-y-auto
                                                                    opacity-0 invisible
                                                                    group-hover:opacity-100 group-hover:visible
                                                                    transition-all duration-300 ease-out
                                                                    "
                                                    >
                                                        <ul>
                                                            {generalInfo[selectedOrg?.id]?.workshops.map((workshop, idx) => (
                                                                <li
                                                                    key={idx}
                                                                    onClick={() => openWorkShopDetails(workshop?.id)}
                                                                    className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                                                                >
                                                                    {workshop.Name}
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>,
                                    document.body
                                )}
                            </td>

                            <td className="relative py-2 text-center align-middle">
                                <span
                                    onClick={(e) => toggleDropdown("labs", e)}
                                    className="min-w-[2.25rem] h-6 inline-flex items-center justify-center text-blue-800 bg-blue-100 px-2 rounded-full cursor-pointer"
                                >
                                    {generalInfo[selectedOrg?.id]?.labs.length}
                                </span>
                                {openDropdown === "labs" && createPortal(
                                    <div className="fixed text-black bg-white border rounded-lg shadow-xl w-48 z-[9999]" style={menuStyle}>
                                        <ul className="text-sm">
                                            <li className="relative">
                                                <div className="group px-4 py-2 hover:bg-gray-100 cursor-pointer whitespace-nowrap">
                                                    معمل ({generalInfo[selectedOrg?.id]?.labs.length})

                                                    {/* bridge area so hover doesn't break */}
                                                    <div className="absolute top-0 w-3 h-full" style={bridgeStyle} />

                                                    {/* Submenu */}
                                                    <div style={subMenuStyle} className="
                                                                    absolute left-full bottom-0 ml-1
                                                                    bg-white border rounded-lg shadow-lg w-44 z-50 max-h-40 overflow-y-auto
                                                                    opacity-0 invisible
                                                                    group-hover:opacity-100 group-hover:visible
                                                                    transition-all duration-300 ease-out
                                                                    "
                                                    >
                                                        <ul>
                                                            {generalInfo[selectedOrg?.id]?.labs.map((lab, idx) => (
                                                                <li
                                                                    key={idx}
                                                                    className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                                                                >
                                                                    {lab.Name}
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>,
                                    document.body
                                )}
                            </td>

                            <td className="py-2 text-center">
                                <span className={`inline-flex items-center justify-center min-w-[2.25rem] px-2 h-6 rounded-full cursor-pointer
                                ${(selectedOrg?.no_of_employees ?? 0) > 0 ? 'bg-blue-100 text-blue-800' : 'bg-slate-100 text-black'}`}>
                                    {generalInfo[selectedOrg?.id]?.classes || 0}
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    )
};

export default WisdomDashboardGeneralInfo;